import CustomMultipleFileUpload from './CustomMultipleFileUpload';

interface FieldOption {
  label: string;
  value: string;
  fields: NestedField[];
}

interface NestedField {
  field_id: string;
  order: number;
  label: string;
  field_type: string;
  tabName: string;
  is_required: boolean;
  value: string;
  values: any[];
  files?: any[];
  field_scope: string;
  table_responses: any[];
  additional_config?: {
    helpText?: string;
    placeholder?: string;
    editable?: boolean;
  };
}

interface CustomMultipleFieldProps {
  name?: string;
  fieldId: string;
  label?: string;
  options?: FieldOption[];
  value?: string;
  defaultValue?: string;
  values?: any[];
  onChange?: (fieldId: string, value: any) => void;
  isRequired?: boolean;
  description?: string;
  isLockedByMe?: boolean;
  lockedOwner?: string;
  isReviewForm?: boolean;
  sectionData?: any;
  helpText?: string;
  onFocus?: () => void;
  isPdf?: boolean;
  isCancel?: boolean;
  setIsCancel?: any;
  className?: string;
  field?: any; // NEW: Add field object
  shouldHighlightNestedField?: (nestedField: any) => boolean; // NEW
}

const CustomFileUpload: React.FC<CustomMultipleFieldProps> = ({
  value,
  label,
  isRequired = false,
  isLockedByMe = false,
  lockedOwner = '',
  isReviewForm = false,
  helpText,
  fieldId,
  onChange,
  values,
  isPdf,
  isCancel,
  className,
  field,
  shouldHighlightNestedField,
}) => {
  const handleNestedFieldChange = (fieldId: string, fileData: any) => {
    if (onChange) {
      const updatedFileData = {
        ...fileData,
        type: 'file',
      };

      onChange(fieldId, updatedFileData);
    }
  };

  const highlightClass =
    shouldHighlightNestedField && field
      ? shouldHighlightNestedField(field)
        ? 'ring-2 ring-[#EF8B21] bg-[#FCF2E6]'
        : ''
      : '';

  return (
    <div className={`w-full ${className}`}>
      <div className={`mb-2 border-b py-4 ${highlightClass}`}>
        <label className="block font-semibold text-ds-gray-800">
          {label} {isRequired && <span className="text-red-500">*</span>}
        </label>
        <p className="text-xs text-ds-gray-400 mt-1">{helpText}</p>

        <CustomMultipleFileUpload
          label={label}
          value={value}
          name={fieldId}
          isCondition={true}
          isLockedByMe={isLockedByMe}
          lockedOwner={lockedOwner}
          isReviewForm={isReviewForm}
          values={values}
          onChange={(fileData) => handleNestedFieldChange(fieldId, fileData)}
          isPdf={isPdf}
          isCancel={isCancel}
        />
      </div>
    </div>
  );
};

export default CustomFileUpload;
